const STORAGE_KEY = 'pending_trip_quote';

function getAppScheme () {
    const scheme = (process.env.TARGET_APP || 'holataxi').toLowerCase();
    return /^[a-z][a-z0-9+.-]*$/.test(scheme) ? scheme : 'holataxi';
}

function getAppName () {
    return process.env.APP_NAME || 'Hola Taxi Patagonia';
}

function getAndroidPackageName () {
    return process.env.ANDROID_PACKAGE_NAME || 'com.movilizame.holataxi';
}

function getPlayStoreUrl () {
    return process.env.PLAY_STORE_URL || `https://play.google.com/store/apps/details?id=${getAndroidPackageName()}`;
}

function getAppStoreUrl () {
    if (process.env.APP_STORE_URL) {
        return process.env.APP_STORE_URL;
    }
    return `https://apps.apple.com/search?term=${encodeURIComponent(getAppName())}`;
}

export function buildAppDownloadUrl (userAgent = (typeof navigator !== 'undefined' ? navigator.userAgent : '')) {
    const ua = userAgent || '';
    if (/iPad|iPhone|iPod/i.test(ua)) {
        return getAppStoreUrl();
    }
    if (/Android/i.test(ua)) {
        return getPlayStoreUrl();
    }
    return getPlayStoreUrl();
}

export function makeLatLngCompat (lat, lng) {
    return {
        lat: function () { return lat; },
        lng: function () { return lng; }
    };
}

export function savePendingTripQuote (quote) {
    if (!quote || typeof quote !== 'object') {
        return;
    }
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(quote));
    } catch (e) {
        console.warn('tripQuoteBridge: could not save quote', e);
    }
}

export function peekPendingTripQuote () {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return null;
        }
        return JSON.parse(raw);
    } catch (e) {
        return null;
    }
}

export function consumePendingTripQuote () {
    const quote = peekPendingTripQuote();
    if (!quote) {
        return null;
    }
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
        // ignore
    }
    return quote;
}

export function quoteFromDeepLinkQuery (query) {
    if (!query || typeof query !== 'object') {
        return null;
    }
    const num = (key) => {
        const v = query[key];
        if (v === undefined || v === null || v === '') {
            return null;
        }
        const n = parseFloat(v);
        return Number.isFinite(n) ? n : null;
    };
    const primaryOriginLat = num('origin_lat');
    const primaryOriginLng = num('origin_lng');
    const primaryDestLat = num('dest_lat');
    const primaryDestLng = num('dest_lng');
    const originLat = primaryOriginLat !== null ? primaryOriginLat : num('olat');
    const originLng = primaryOriginLng !== null ? primaryOriginLng : num('olng');
    const destLat = primaryDestLat !== null ? primaryDestLat : num('dlat');
    const destLng = primaryDestLng !== null ? primaryDestLng : num('dlng');
    if (originLat === null || originLng === null || destLat === null || destLng === null) {
        return null;
    }
    return {
        origin_lat: originLat,
        origin_lng: originLng,
        dest_lat: destLat,
        dest_lng: destLng,
        origin_desc: query.origin_desc || query.od || '',
        dest_desc: query.dest_desc || query.dd || '',
        es_ida_vuelta: query.es_ida_vuelta === '1' || query.es_ida_vuelta === 'true' || query.iv === '1',
        tipo_vehiculo: query.tipo_vehiculo ? parseInt(query.tipo_vehiculo, 10) : undefined,
        tipo_servicio: query.tipo_servicio ? parseInt(query.tipo_servicio, 10) : undefined,
        tipo_beneficio: query.tipo_beneficio || query.tb || ''
    };
}

export function buildDeepLinkUrl (quote) {
    const scheme = getAppScheme();
    const params = new URLSearchParams();
    params.set('origin_lat', String(quote.origin_lat));
    params.set('origin_lng', String(quote.origin_lng));
    params.set('dest_lat', String(quote.dest_lat));
    params.set('dest_lng', String(quote.dest_lng));
    if (quote.origin_desc) {
        params.set('origin_desc', quote.origin_desc);
    }
    if (quote.dest_desc) {
        params.set('dest_desc', quote.dest_desc);
    }
    if (quote.es_ida_vuelta) {
        params.set('es_ida_vuelta', '1');
    }
    if (quote.tipo_vehiculo) {
        params.set('tipo_vehiculo', String(quote.tipo_vehiculo));
    }
    if (quote.tipo_servicio) {
        params.set('tipo_servicio', String(quote.tipo_servicio));
    }
    if (quote.tipo_beneficio) {
        params.set('tipo_beneficio', quote.tipo_beneficio);
    }
    return `${scheme}://pedir-viaje?${params.toString()}`;
}

export function buildQuotePayload (origin, dest, options = {}) {
    if (!origin || !origin.location || !dest || !dest.location) {
        return null;
    }
    const destLat = typeof dest.location.lat === 'function' ? dest.location.lat() : dest.location.lat;
    const destLng = typeof dest.location.lng === 'function' ? dest.location.lng() : dest.location.lng;
    return {
        origin_lat: origin.location.lat,
        origin_lng: origin.location.lng,
        dest_lat: destLat,
        dest_lng: destLng,
        origin_desc: options.origin_desc || '',
        dest_desc: options.dest_desc || dest.description || '',
        es_ida_vuelta: !!options.es_ida_vuelta,
        tipo_vehiculo: options.tipo_vehiculo,
        tipo_servicio: options.tipo_servicio,
        tipo_beneficio: options.tipo_beneficio || ''
    };
}



// WEBPACK FOOTER //
// ./src/services/tripQuoteBridge.js